export default __webpack_public_path__ + "static/media/white-logo.2372f75c.png";